import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    List,
} from '@mui/material'

import CardListItem from "../listitem/CardListItem";
import {useFetch} from '../../components/auth/useFetch';

export default function CreateProjectModal(props){

    const { handleSwitch, projects, setBreadCrumbs } = props

    const { isAuthenticated } = useAuth0()

    const [activeStep, setActiveStep] = useState(0)
    const [availableDatabases, setAvailableDatabases] = useState([])
    const fetchWithAuth = useFetch()

    useEffect(() => {
        isAuthenticated && (async () => {
            try {
                setBreadCrumbs(['Create A Project'])
            } catch (e) {
                console.error(e);
            }
        })();
    }, [isAuthenticated])

    const getDatabases = () => {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/databases/osd`, {
            headers: {
                'X-Project-ID': 'Konsol'
            }
        })
        .then(res => {
            if(!res.ok){
                throw new Error('Failed to communicate with OSD Server')
            }
            return res.json()
        })
        .then(res => {
            setAvailableDatabases(res.map(item => ({
                primaryText: item,
                onClick: () => createKonsolProject(item),
                isActive: projects.some(project => project.project_db?.toLowerCase() === item.toLowerCase()), // db_name in MongoDB is case insensitive
            }) ))
        })
        .then(() => {
            setActiveStep(1)
            setBreadCrumbs(prev => prev.concat('OSD'))
        })
        .catch(e => console.error(e))
    }

    const createKonsolProject = (item) => {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/databases/`, {
            method: 'POST',
            body: JSON.stringify({
                project_db: item
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-Project-ID': 'Konsol'
            }
        })
        .then(res => {
            if(!res.ok){
                throw new Error('Failed to create new Konsol Project')
            }
        })
        .then(() => {
            handleSwitch({
                project_db: item,
                project_name: item
            })
        })
        .catch(e => console.error(e))
    }

    return (
        <React.Fragment>
            {activeStep === 0 &&
                    [
                        {
                            primaryText: 'On-Set Dailies',
                            secondaryText: 'ColorFront',
                            onClick: () => getDatabases(),
                        }, 
                        {
                            primaryText: 'ALE',
                            secondaryText: 'Custom',
                        }
                    ].map((item, index) => (
                        <Box
                            px={1}
                            py={0.5}
                        >
                            <CardListItem
                                key={index}
                                primary={item?.primaryText}
                                secondary={item?.secondaryText}
                                item={item}
                            />
                        </Box>
                    ))
            }
                {activeStep === 1 &&
                    availableDatabases.map((item, index) => (
                        <Box
                            px={1}
                            py={0.5}
                        >
                            <CardListItem
                                key={index}
                                item={item}
                                primary={item?.primaryText}
                                avatar={item?.primaryText?.charAt(0) ?? 'K'}
                                isActive={item?.isActive}
                                isEnabled={!item?.isActive}
                            />
                        </Box>
                    ))
                }
        </React.Fragment>
    )
}